var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.suKien && _vm.suKien.content)?_c('div',{staticClass:"marquee event mb-2"},[_c('div',{staticClass:"marquee-track"},[_c('span',[_vm._v(_vm._s(_vm.suKien.content))]),_c('span',[_vm._v(_vm._s(_vm.suKien.content))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }